<div [ngClass]="showSidebar ? 'd-none' : ''">
    <div class="d-flex room-container" #container>
        <div
          *ngFor="let choice of dataEntries;
                  let indexOfelement=index;
                  let isEven = even;
                  let isOdd = odd;
                  let isFirst = first;
                  let isLast = last"
                  class="w-item d-inline-flex"
        >

        <app-spinner
          [title]="choice.RoomGroupName+'_B2C'"
          (onSpinnerUpd)="onRoomSpinnerUpd($event, choice.SubRooms[0].ID)"
          [value]="choice.SubRooms[0].Quantity"
          [tooltip]="choice.tooltip"
          [id]="choice.SubRooms[0].ID"
          [imageClassFromFrontEnd]="choice.imageClassFromFrontEnd"
          min="0"
          max="4"
          class="w-100 row-item p-row-item"
          [ngClass]="{

                        'p-t-25': indexOfelement != 0 && indexOfelement != 1,
                        'even': isEven,
                        'odd': isOdd,
                        'first': isFirst,
                        'last': isLast,
                        'evidence' : choice.SubRooms[0].Quantity > 0
                      }"
        ></app-spinner>
        </div>
    </div>
</div>

<app-lateral-panel id="subtitle-info-lateral" class="subtitle-info-lateral primary accordion"  [extraClasses]="'m-w-768'" [(showSidebar)]="showSidebar">
  <div class="row d-flex justify-content-between align-items-center button-row exit-row panel-title">
    <h3 class="primary m-b-question m-t-question" [innerHTML]= "question | translate"></h3>
    <button
      mat-flat-button
      class="bticino-ico close round-button-with-background transparent-background"
      style="width: 40px; height: 40px"
      (click)="onCloseTooltip()"
    >
    </button>
  </div>
  <mat-accordion
    [multi]="false"
    class="row d-flex flex-row flex-wrap justify-content-between expansion-panel-container m-b-row panel-description"
  >
    <div
      *ngFor="let entry of dataEntries; let isFirst = first; let isLast = last"
      class="expansion-panel-container d-inline-block m-b-45 w-100 m-w-accordion m-b-panel-container"
      [ngClass]="{
        'first': isFirst,
        'last': isLast
      }"

    >
      <mat-expansion-panel class="border" >
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center">
            <span
              class="bticino-ico {{entry.imageClassFromFrontEnd}} m-r-26 background-color-transparent"
            >
            &nbsp;
            </span>
            <span class="font-bticino-bold">
              {{entry.RoomGroupName+'_B2C' | translate}}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{entry.tooltip | translate}}</p>
        <div *ngIf="(entry.SubRooms[0].SuperficieMin != 0) || (entry.SubRooms[0].SuperficieMax != 0)" class="d-flex align-items-center">
          <span class="bticino-ico ic-metri m-r-ico background-color-transparent" ></span>
          <span *ngIf="(entry.SubRooms[0].SuperficieMin == 0)">{{ 'roomType.IDS_SMALLERTHAN' | translate }} {{entry.SubRooms[0].SuperficieMax}} m<sup>2</sup> </span>
          <span *ngIf="(entry.SubRooms[0].SuperficieMin != 0) && (entry.SubRooms[0].SuperficieMax != 0)">{{ 'roomType.IDS_FROM' | translate }} {{entry.SubRooms[0].SuperficieMin}} {{ 'roomType.IDS_TO' | translate }} {{entry.SubRooms[0].SuperficieMax}} m<sup>2</sup> </span>
          <span *ngIf="(entry.SubRooms[0].SuperficieMax == 0)">{{ 'roomType.IDS_GREATERTHAN' | translate }} {{entry.SubRooms[0].SuperficieMin}} m<sup>2</sup> </span>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>

</app-lateral-panel>
